import useApolloClient from '../hooks/useApolloClient';
import { Route, Switch } from 'react-router-dom';
import { ModeProvider } from '../hooks/useMode';
import Jobs from '../pages/jobs/Jobs';
import Home from '../pages/Home';
import { ApolloProvider } from '@apollo/client';
import React from 'react';
import TesterProfile from './individual/pages/profile/TesterProfile';
import Activity from '../pages/activity/Activity';
import NotificationSettings from './common/pages/settings/NotificationSettings';
import ActivityHandler from '../components/ActivityFeed/ActivityHandler';
import { TwoFactorPrompt } from '../components/Security';

const Individual = () => {
  return (
    <ApolloProvider client={useApolloClient('individual')}>
      <ModeProvider value="individual">
        <ActivityHandler />
        <TwoFactorPrompt />
        <Switch>
          <Route path="/individual/activity" component={Activity} />
          <Route
            path={['/individual/jobs/:id', '/individual/jobs']}
            component={Jobs}
          />
          <Route
            path="/individual/notification-settings"
            component={NotificationSettings}
          />
          <Route path="/individual/profile" component={TesterProfile} />
          <Route path="/individual" component={Home} />
        </Switch>
      </ModeProvider>
    </ApolloProvider>
  );
};

export default Individual;
